module.exports = __webpack_public_path__ + "img/haters-1.4b8e3cf7.png";